import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { PlannerView } from "../VIEW/PlannerView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function PlannerPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.PLANNER}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <PlannerView uid={user.uid} email={user.email || ""} />;
}

export default PlannerPage;
